"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ILabel", {
  enumerable: true,
  get: function get() {
    return _Label2.ILabel;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Label["default"];
  }
});
var _Label = _interopRequireDefault(require("./Label"));
var _Label2 = require("./Label.model");